export const intervalTimeInMs = 3000;
export const maxWaitingTimeInMs = 3000;
export const maxErrorWaitingTimeInMs = 60000;
